import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

import { DEFAULT_LOAD_MORE, DEFAULT_PAGE_NUMBER } from '../../../../constants';
import { clientRequirementsRoute } from '../route';

import { bankProductsAndServicesFilterFormSchema } from './components/bankProductsAndServicesFilterFormSchema';

const bankProductsAndServicesValidateSearchSchema = z.object({
	openedRequirement: z.string().optional(),
	filter: bankProductsAndServicesFilterFormSchema.catch({
		operationType: undefined,
		operationStatuses: [],
	}),
	pageNumber: z.number().default(DEFAULT_PAGE_NUMBER),
	loadMore: z.number().default(DEFAULT_LOAD_MORE),
});

export const clientBankProductsAndServicesRoute = createRoute({
	path: '/bank-products-and-services',
	getParentRoute: () => clientRequirementsRoute,
	component: lazyRouteComponent(
		() => import('./ClientBankProductsAndServicesPage'),
		'ClientBankProductsAndServicesPage',
	),
	validateSearch: bankProductsAndServicesValidateSearchSchema,
});
